import React from 'react';
import Badge from './Badge';
import SparkIcon from './SparkIcon';

/**
 * Self-contained badge for marking Pro-tier features.
 * Can be used without props — just `<ProBadge />`.
 * Accepts an optional `className` to adjust margins, padding, etc.
 */
const ProBadge: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <Badge
            text="Pro"
            color="brand"
            appearance="filled"
            shape="rounded"
            icon={<SparkIcon />}
            iconPosition="end"
            className={className}
        />
    );
};

export default ProBadge;
